import { Link } from 'react-router-dom';
import { videos } from '@/mocks/data';

export default function LatestContent() {
  const latestVideos = videos.filter((v) => v.isNew);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
              最新上线
            </h2>
            <p className="text-sm text-foreground-600">刚刚更新的新鲜内容，不要错过</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group flex gap-4 bg-background-100 rounded-xl p-3 hover:bg-background-200/70 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-36 sm:w-44 flex-shrink-0 aspect-video rounded-lg overflow-hidden">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <span className="absolute bottom-2 left-2 px-1.5 py-0.5 rounded bg-black/60 text-background-50 text-xs whitespace-nowrap">
                  {video.duration}
                </span>
              </div>
              <div className="flex-1 min-w-0 py-1">
                <h3 className="text-sm font-semibold text-foreground-950 mb-1.5 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-2">{video.description}</p>
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{video.views}次播放</span>
                  <span className="text-foreground-300 text-xs">·</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{video.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}